<style lang="less" scoped>
.check-bank-card{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  .bank-icon{
    width: 108px;
    margin: 16px auto;
  }
  .bank-icon-layer {
    margin: 16px auto;
  }
  .check-message{
    font-size: 12px;
    color: #4a4a4a;
    padding-bottom: 16px;
  }
  .bank-card-input{
    position: relative;
    width: 100%;
    input{
      width: 100%;
      height: 44px;
      margin: 0 auto;
      background-color: rgb(252, 252, 252);
      border-radius: 4px;
      border: solid 0.5px #d2d2d2;
      text-indent: 14px;
    }
    input::placeholder {
      color: #9b9b9b;
      box-sizing: border-box;
      background-color: rgb(252, 252, 252);
    }
    .clean-input{
      width: 24px;
      width: 24px;
      position: absolute;
      top: 10px;
      right: 13px;
    }
    .error-msg{
      font-size: 12px;
      color: #ff5000;
    }

  }
  .check-btn{
    width: 100%;
    height: 44px;
    border-radius: 4px;
    background-image: linear-gradient(275deg, #ff396d, #ff7232);
    line-height: 44px;
    text-align: center;
    color: #fff;
    font-size: 17px;
    margin: 69px;
  }
}
</style>

<template>
  <div class="check-bank-card">
    <img class="bank-icon" :src="logo" v-if="logo"/>
    <div class="bank-icon-layer" v-else></div>
    <div class="check-message">请填写银行卡号，为了您的信息安全，将由银联进行实时认证，卖座电影不会保存任何卡号信息。</div>
    <div class="bank-card-input">
      <input type="number" placeholder="请输入银行卡号" maxlength="19" v-model="bankCard" @blur="checkInput" />
      <img class="clean-input" src="../../../../image/preorder/close.png"  @click="cleanInput"/>
      <div class="error-msg">{{errorMsg}}</div>
    </div>
    <div class="check-btn" @click="toCheck">验证</div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getHostName } from '../../../util/function.js'
import RSA from '../../../util/ACT_RSA.js'

const rsa = new RSA()

export default {
  data() {
    return {
      bankCard: '',
      errorMsg: '',
    }
  },
  computed: {
    payOrderId() {
      return this.$route.query.payOrderId
    },
    activeCode() {
      return this.$route.query.activeCode
    },
    logo() {
      return decodeURIComponent(this.$route.query.payLogo) || ''
    },
    payType() {
      return parseInt(this.$route.query.payType)
    },
  },
  watch: {
    bankCard() {
      this.errorMsg = ''
    }
  },
  methods: {
    ...mapActions([
      'checkCardBin',
      'thirdPartPay',
    ]),
    checkInput() {
      if (this.bankCard.length < 16) {
        this.errorMsg = '请输入正确的银行卡号'
      }
    },
    toCheck() {
      if (this.errorMsg === '请输入正确的银行卡号') {
        return
      }
      this.errorMsg = ''
      this.checkCardBin({
        activeCode: this.activeCode,
        payAccount: rsa.encrypt(this.bankCard, 'base64'),
        payType: this.payType,
        payOrderId: this.payOrderId,
      }).then(({ token }) => {
        return this.thirdPartPay({
          payAccount: rsa.encrypt(this.bankCard, 'base64'),
          payOrderId: this.payOrderId,
          payType: this.payType,
          payToken: token,

          ////v5/#/preorder/${this.payOrderId}/pay/callback/1?productType=${self.productsType}&orderType=${self.orderType}&rd=${+new Date()}
          returnUrl: `${getHostName()}/mz-act/pay/callback/${this.payOrderId}?activeCode=${this.activeCode}&payType=${this.payType}`,
        })
      }).then((data) => {
        console.log("data", data)
        document.write(data.pageHtml)
      }).catch( err => {
        this.errorMsg = err
      })
    },
    cleanInput() {
      this.bankCard = ''
      this.errorMsg = ''
    },
  }
}
</script>
